<script>
  // Перенос Grid из parts.tsx — сетка карточек.
  export let size = undefined;   // 'narrow' | 'wide'
  let className = '';
  export { className as class };
</script>

<div class={'mn-grid' + (size ? ' ' + size : '') + (className ? ' ' + className : '')}><slot /></div>
